
import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./Partners.css";

const Partners = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Partners", "partner/partner_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Partners || { Main: {} };
  const partners = [
    {
      title: LANGUAGE.Main.Content1,
      image: "/img/partners1.png",
      delay: '0.2s',
    },
    {
      title: LANGUAGE.Main.Content3,
      image: "/img/partners2.png",
      delay: '0.4s',
    },

  ];

  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{
        visibility: 'visible',
        animationDelay: '0.1s',
        animationName: 'fadeInUp',
      }}
    >
      <div className="container py-5">
        <div
          className="section-title text-center position-relative pb-3 mb-5 mx-auto"
          style={{ maxWidth: '600px' }}
        >
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content2}</h5>
          <h1 className="mb-0">
            {LANGUAGE.Main.Content1}
          </h1>
        </div>
        <div className="row g-5">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="col-lg-6 wow zoomIn"
              data-wow-delay={partner.delay}
              style={{
                visibility: 'visible',
                animationDelay: partner.delay,
                animationName: 'zoomIn',
              }}
            >
              <img src={partner.image} alt={partner.title} className="feature-img" />

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
